import Vue from 'vue'
import Router from 'vue-router'
import Login from './pages/Login2.vue'
import Menu from './pages/Menu.vue'
import Recos from './pages/recos.vue'
import Reco from './pages/Reco.vue'
import RecoPassenger from './pages/RecoPassenger.vue'
import Zarpes from './pages/zarpes.vue'
import Zarpe from './pages/Zarpe.vue'
import Production from './pages/Production.vue'
import ProductionDay from './pages/ProductionDay.vue'
import ProductionMonth from './pages/ProductionMonth.vue'
import ProductionCalendar from './pages/ProductionCalendar.vue'
import ProductionCalendarResult from './pages/ProductionCalendarResult.vue'
import Messages from './pages/Messages.vue'
import ME from './pages/ME.vue'
import RTX from './pages/RTX.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/menu',
      name: 'Menu',
      component: Menu
    },
    {
      path: '/recos',
      name: 'Recos',
      component: Recos
    },
    {
      path: '/reco/:id',
      name: 'Reco',
      component: Reco
    },
    {
      path: '/recos/:id_pay/start/:passenger_ID',
      name: 'RecoPassenger',
      component: RecoPassenger
    },
    {
      path: '/zarpes',
      name: 'Zarpes',
      component: Zarpes
    },
    {
      path: '/zarpe/:id',
      name: 'Zarpe',
      component: Zarpe
    },
    {
      path: '/production',
      name: 'Production',
      component: Production
    },
    {
      path: '/production/day',
      name: 'ProductionDay',
      component: ProductionDay
    },
    {
      path: '/production/month',
      name: 'ProductionMonth',
      component: ProductionMonth
    },
    {
      path: '/production/calendar',
      name: 'ProductionCalendar',
      component: ProductionCalendar
    },
    {
      path: '/production/calendar-result/:initDate/:endDate',
      name: 'ProductionCalendarResult',
      component: ProductionCalendarResult
    },
    {
      path: '/messages',
      name: 'Messages',
      component: Messages
    },
    {
      path: '/me',
      name: 'ME',
      component: ME
    },
    {
      path: '/rtx',
      name: 'RTX',
      component: RTX
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router.js